import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductPage from "./pages/ProductPage";
import Hub from "./pages/Hub";
import ArticlePage from "./pages/ArticlePage";
import UtilityPage from "./pages/UtilityPage";
import Collection from "./pages/Collection";
import CollectionPiece from "./pages/CollectionPiece";
import NotFound from "./pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid rgba(255,255,255,.22)",
            color: "#FFFFFF",
            fontFamily: "'Inter', sans-serif",
            borderRadius: 0,
          },
        }}
      />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:slug" element={<ProductPage />} />
          <Route path="/mindset" element={<Hub hubKey="mindset" />} />
          <Route path="/train" element={<Hub hubKey="train" />} />
          <Route path="/recover" element={<Hub hubKey="recover" />} />
          <Route path="/mindset/:slug" element={<ArticlePage />} />
          <Route path="/contact" element={<UtilityPage page="contact" />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/collection/:slug" element={<CollectionPiece />} />
          <Route path="/shipping" element={<UtilityPage page="shipping" />} />
          <Route path="/returns" element={<UtilityPage page="returns" />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
